import { useMutation } from '@apollo/client'
import { gql } from 'apollo-boost'

export default () => {
  const [mutate] = useMutation(
    gql`
      mutation submitRun($input: SubmitRunInput!) {
        submitRun(input: $input) {
          run {
            id
            name
            mileage
            timestamp
          }
        }
      }
    `
  )

  return (input) => mutate({ variables: { input } })
}
